export default __webpack_public_path__ + "static/media/aisec.b3e064d3.png";